import { Component } from '@angular/core';
import { InternationalRequest } from '../data/international-request';
import { InternationalRequestService } from '../services/international-request.service';
import { Dealer, DealerCurrent } from '../data/dealer';
import { FuncsService } from '../services/funcs.service';

interface status {
   id: number;
   name: string;
}

@Component({
  selector: 'app-request-intl',
  templateUrl: './request-intl.component.html',
  styleUrl: './request-intl.component.css',
  standalone: false
})
export class RequestIntlComponent {
  selectedStatus = 100;

  constructor(
    private internationalRequestService: InternationalRequestService,
    // private fordService: FordService,
    private funcs: FuncsService
  ) {}

  public loading = true;
  public f = this.funcs;
  report: InternationalRequest[] = [];
  dealer: Dealer = DealerCurrent;
  selectedOption = "";

  statuses: status[] = [
    {"id": 100, "name": "Request Submitted"},
    {"id": 200, "name": "Program Administrator Approved"},
    {"id": 300, "name": "Manager Approved"},
    {"id": 400, "name": "Complete"},
    {"id": 901, "name": "Program Administrator Denied"},
    {"id": 902, "name": "Manager Denied"},
    {"id": 999, "name": "Stopped"}
  ];

  changeStatus(eventEnroll: Event) {
    this.getRequests();
  }

  async ngOnInit(): Promise<void> {
    this.getRequests();
    // this.funcs.currentDealer(this.dealer);
    // this.getSubscription();
    // this.loading = false;
  }

  approvalButton(statusId: number): string {
    switch (statusId) {
      case 100:
        return "Approve (Program Administrator)";
      case 200:
        return "Approve (Manager)";
      case 300:
        return "Complete";
      case 400:
        return "";
      case 901:
        return "Approve (Program Administrator)";
      case 902:
        return "Approve (Manager)";
      case 999:
        return "Restart";
      default:
        return "";
    }
  }

  denyButton(statusId: number): string {
    switch (statusId) {
      case 100:
        return "Deny (Program Administrator)";
      case 200:
        return "Deny (Manager)";
      case 300:
        return "Deny (Manager)";
      case 400:
        return "Reopen";
      case 901:
        return "";
      case 902:
        return "";
      case 999:
        return "";
      default:
        return "";
    }
  }

  requestTechs(): void {
    // add to queue
    // (Use the old site for email)
    // display confirmation
    // this.requested = true;
  }

  getRequests(): void {
    this.internationalRequestService.getInternationalRequestsByStatus(this.selectedStatus).subscribe(report => {
      this.report = report;
      this.loading = false;
    });
  }
}
